import React from 'react';

import ContactMap from './ContactMap';
const GlobalOffices = () => {
    return (
        <div >
            {/* <NewsandeventsBanner /> */}
            {/* <PoadcostBanner /> */}
            {/* <GlobalofficesBanner /> */}
            {/* <Poadcostvideossections /> */}
            {/* <Newsandeventscards /> */}
            {/* <SocialResponsibilitesBanner /> */}
            {/* <Socialresponsesectioncontetn /> */}
            {/* <SocailresponsibilitesAdvviser /> */}
          <ContactMap />
        </div>
    );
};

export default GlobalOffices;
